import { render, staticRenderFns } from "./ClickChange.vue?vue&type=template&id=cabd8fc6&"
import script from "./ClickChange.vue?vue&type=script&lang=js&"
export * from "./ClickChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports